import { TRANSFER } from '../../booking/models/transfer';

// Mirrors airportliner_be/utils/holiday-booking-blocks.js. The rules arrive via
// dictionary.holidayBookingBlocks; the backend enforces them, this only drives the hint.

// 'HH:MM', 'H:MM' or 'HH:MM:SS' -> minutes since midnight, null if unusable
const toMinutes = (time) => {
    if (!time) {
        return null;
    }
    const [hours, minutes] = String(time).split(':');
    const total = parseInt(hours, 10) * 60 + (parseInt(minutes, 10) || 0);
    return Number.isNaN(total) ? null : total;
};

// The date must be the typed 'YYYY-MM-DD' string (Munich wall-clock day, see
// DetailFields.onDateChange). A Date object or an ISO datetime would carry a
// time zone and could land on the wrong day, so anything else is "not evaluable".
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// exact 'YYYY-MM-DD' entries win over recurring 'MM-DD' entries
const findBlockForDate = (isoDate, blocks) =>
    blocks.find((block) => block.date === isoDate) || blocks.find((block) => block.date === isoDate.slice(5)) || null;

const findHolidayBlockViolation = (transfer, blocks) => {
    const isToAirport = transfer?.typeId === TRANSFER.TO_MUNICH;
    const isFromAirport = transfer?.typeId === TRANSFER.FROM_MUNICH;
    if ((!isToAirport && !isFromAirport) || !Array.isArray(blocks) || blocks.length === 0) {
        return null;
    }

    const isoDate = transfer.flight?.date;
    const time = toMinutes(isToAirport ? transfer.arrivalTime : transfer.flight?.time);
    if (typeof isoDate !== 'string' || !DATE_ONLY.test(isoDate) || time === null) {
        return null;
    }

    const block = findBlockForDate(isoDate, blocks);
    if (!block) {
        return null;
    }

    const window = isToAirport ? block.toAirport : block.fromAirport;
    if (time < toMinutes(window.from)) {
        return { date: isoDate, bound: 'from', time: window.from };
    }
    if (time > toMinutes(window.until)) {
        return { date: isoDate, bound: 'until', time: window.until };
    }
    return null;
};

export { findHolidayBlockViolation };
